import { render, staticRenderFns } from "./bio.vue?vue&type=template&id=20894df2"
import script from "./bio.vue?vue&type=script&lang=ts"
export * from "./bio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports